import axios, { AxiosError } from 'axios';
import { AuthHelper } from 'src/components/Auth/AuthHelper';
import { AuthConfiguration } from 'src/components/Auth/authConfiguration';
import { env } from 'src/config/env';

const API = axios.create({
  baseURL: env.isDev ? env.apiAddress : `${location.origin}/api/v1.0/`,
  timeout: 90000,
});

API.interceptors.request.use(
  async (config) => {
    const token = AuthHelper.getAccessToken();
    const customerId = sessionStorage.getItem('customerId');
    config.headers['Authorization'] = "Bearer " + token;
    if (!config.params) {
      config.params = {};
    }
    if (customerId) {
      config.params.customerId = customerId;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

API.interceptors.response.use(function (response) {
  return response;
}, async function (error: AxiosError) {

  if (error.response?.status === 401) {
    let mp = new Map();
    error.response.headers['www-authenticate']
      .split(' ')
      .map((x: string) => {
        let keyValue = x.replace(',', '').replaceAll('"', '').split('=');
        mp.set(keyValue[0], keyValue[1]);
      });

    AuthHelper.removeAccessToken();

    const authConfig: AuthConfiguration = {
      clientId: mp.get('client_id'),
      authority: mp.get('authorization_uri'),
      domain: mp.get('domain'),
      apiScopes: [mp.get('scope')],
      redirectUri: mp.get('redirect_uri'),
      postLogoutRedirectUri: mp.get('landing_page_uri'),
    };

    await AuthHelper.init(authConfig);
  }
  return Promise.reject(error);
});
export default API;
